// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2y6oG","error":"Textarea_error__1TJHa","readonly":"Textarea_readonly__yBccg","disabled":"Textarea_disabled__1bs0o"};